/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateDeliveryParcel201ResponseAllOfData } from './CreateDeliveryParcel201ResponseAllOfData';
import {
    CreateDeliveryParcel201ResponseAllOfDataFromJSON,
    CreateDeliveryParcel201ResponseAllOfDataFromJSONTyped,
    CreateDeliveryParcel201ResponseAllOfDataToJSON,
} from './CreateDeliveryParcel201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateDeliveryParcel201ResponseAllOf
 */
export interface CreateDeliveryParcel201ResponseAllOf {
    /**
     * 
     * @type {CreateDeliveryParcel201ResponseAllOfData}
     * @memberof CreateDeliveryParcel201ResponseAllOf
     */
    data: CreateDeliveryParcel201ResponseAllOfData;
}

/**
 * Check if a given object implements the CreateDeliveryParcel201ResponseAllOf interface.
 */
export function instanceOfCreateDeliveryParcel201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateDeliveryParcel201ResponseAllOfFromJSON(json: any): CreateDeliveryParcel201ResponseAllOf {
    return CreateDeliveryParcel201ResponseAllOfFromJSONTyped(json, false);
}

export function CreateDeliveryParcel201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeliveryParcel201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateDeliveryParcel201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function CreateDeliveryParcel201ResponseAllOfToJSON(value?: CreateDeliveryParcel201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateDeliveryParcel201ResponseAllOfDataToJSON(value.data),
    };
}

